/**
 * DemoHeader - Header for demo pages matching the static landing page style exactly
 * Provides consistent branding with CLEAR wordmark + NRC badge + navigation
 * Styled to match public/landing/index.html header
 */

import { Link, useLocation } from 'react-router-dom';

export function DemoHeader() {
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/demo') {
      return location.pathname === '/demo' || location.pathname.startsWith('/wireframes');
    }
    return location.pathname === path;
  };

  return (
    <>
      <header
        className="fixed top-0 left-0 right-0 z-50 bg-white"
        style={{ borderBottom: '1px solid #E5E7EB' }}
      >
        <div
          className="mx-auto flex items-center justify-between"
          style={{
            maxWidth: '1200px',
            padding: '0.75rem 1.5rem',
          }}
        >
          {/* Logo Group */}
          <div className="flex items-center gap-3">
            <Link
              to="/"
              className="hover:opacity-80 transition-opacity"
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '1.5rem',
                fontWeight: 600,
                color: '#0D0D0D',
                letterSpacing: '0.05em',
                textTransform: 'uppercase',
              }}
            >
              CLEAR
            </Link>
            <span
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '0.65rem',
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#4B5563',
                background: '#F3F4F6',
                padding: '0.25rem 0.5rem',
              }}
            >
              NRC
            </span>
          </div>

          {/* Navigation */}
          <nav className="hidden lg:flex items-center gap-8">
            <a
              href="/#vision"
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#0D0D0D',
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#fd5a00'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#0D0D0D'}
            >
              Vision
            </a>
            <a
              href="/#challenge"
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#0D0D0D',
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#fd5a00'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#0D0D0D'}
            >
              Challenge
            </a>
            <a
              href="/#product"
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#0D0D0D',
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#fd5a00'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#0D0D0D'}
            >
              Product
            </a>
            <a
              href="https://clearinitiative.io/CLEAR_Validation_Report_External_Final.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#0D0D0D',
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#fd5a00'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#0D0D0D'}
            >
              Report
            </a>
            <a
              href="/#signup"
              style={{
                fontFamily: 'Roboto, -apple-system, BlinkMacSystemFont, sans-serif',
                fontSize: '0.75rem',
                fontWeight: 500,
                textTransform: 'uppercase',
                letterSpacing: '0.05em',
                color: '#0D0D0D',
                transition: 'color 0.2s ease',
              }}
              onMouseEnter={(e) => e.currentTarget.style.color = '#fd5a00'}
              onMouseLeave={(e) => e.currentTarget.style.color = '#0D0D0D'}
            >
              Contact
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="lg:hidden flex items-center justify-center"
            style={{
              width: '40px',
              height: '40px',
              border: 'none',
              background: 'transparent',
              cursor: 'pointer',
              color: '#0D0D0D',
            }}
            aria-label="Toggle menu"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <line x1="3" y1="12" x2="21" y2="12" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <line x1="3" y1="18" x2="21" y2="18" />
            </svg>
          </button>
        </div>
      </header>
    </>
  );
}

export default DemoHeader;
